import { kuferClient } from '@xver/libs/axios';

import type {
    CreateCredentialRequest,
    CreateCredentialResponse,
    GetCredentialResponse,
    ListCredentialsResponse,
    UpdateCredentialRequest,
} from './model';

const ENDPOINTS = {
    LIST: '/v1/registry/credentials',
    CREATE: '/v1/registry/credentials',
    GET: (id: string) => `/v1/registry/credentials/${id}`,
    UPDATE: (id: string) => `/v1/registry/credentials/${id}`,
    DELETE: (id: string) => `/v1/registry/credentials/${id}`,
};

export function listCredentials(): Promise<ListCredentialsResponse> {
    return kuferClient.get(ENDPOINTS.LIST);
}

export function getCredential(id: string): Promise<GetCredentialResponse> {
    return kuferClient.get(ENDPOINTS.GET(id));
}

export function createCredential(data: CreateCredentialRequest): Promise<CreateCredentialResponse> {
    return kuferClient.post(ENDPOINTS.CREATE, data);
}

export function updateCredential(id: string, data: UpdateCredentialRequest): Promise<void> {
    return kuferClient.put(ENDPOINTS.UPDATE(id), data);
}

export function deleteCredential(id: string): Promise<void> {
    return kuferClient.delete(ENDPOINTS.DELETE(id));
}
